import React, {useEffect, useState} from "react";
import styled from "styled-components";
import LunchImg from "../../../../../../assets/lunchSpecial.png";
import Button from "components/molecules/Button";
import {RiArrowDownSLine} from "react-icons/ri";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import {useForm} from "components/molecules/Form";
import ModalContainer from "components/molecules/ModalContainer";
import AddCategoryModal from "./AddCategoryModal";

const itemsData = [
    {
        title: "Main Items",
        required: true,
        items: ["Zinger Burger", "Chicken Wrap", "Beef Burger", "Fish Fillet"],
    },
    {
        title: "Side Items",
        required: true,
        items: ["Fries", "Onion Rings", "Coleslaw", "Mashed Potato"],
    },
    {
        title: "Drinks",
        required: true,
        items: ["Pepsi", "Sprite", "Fanta", "Orange Juice"],
    },
    {
        title: "Desserts",
        items: ["Ice Cream", "Apple Pie", "Chocolate Cake", "Cookies"],
    },
];

const StyledSelectItems = styled(Form)`
    width: 100%;
    .desc-wrap {
        padding: 20px;
        border-radius: 15px;
        background: rgba(245, 126, 42, 0.1);
        text-align: center;
        margin-bottom: 20px;
        .title {
            display: block;
            color: var(--text-color);
            font-size: 18px;
            line-height: 22px;
            font-weight: 500;
            margin-bottom: 8px;
        }
        .desc {
            display: block;
            color: var(--text-color);
            font-size: 16px;
            line-height: 20px;
            font-weight: 300;
            margin-bottom: 20px;
        }
        .items-selected {
            padding: 7px 10px;
            border-radius: 30px;
            background-color: var(--primary);
            color: var(--white);
            font-size: 14px;
            line-height: 18px;
            font-weight: 400;
        }
    }
    .add-category-wrap {
        padding: 20px 15px;
        border-radius: 15px;
        background: rgba(39, 196, 83, 0.1);
        margin-bottom: 15px;
        .title {
            display: block;
            color: rgba(39, 196, 83, 1);
            font-size: 18px;
            line-height: 22px;
            font-weight: 500;
            margin-bottom: 8px;
        }
        .desc {
            display: block;
            color: var(--text-color);
            font-size: 16px;
            line-height: 20px;
            font-weight: 300;
            margin-bottom: 20px;
        }
        .add-category {
            padding: 7px 10px;
            border-radius: 30px;
            background-color: rgba(39, 196, 83, 1);
            color: var(--white);
            font-size: 14px;
            line-height: 18px;
            font-weight: 400;
            cursor: pointer;
        }
    }
    .selection-wrap {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 20px;
        border-radius: 15px;
        background: rgba(245, 126, 42, 0.1);
        margin-bottom: 40px;
        .img {
            width: 75px;
            height: 75px;
            border-radius: 8px;
        }
        .details {
            .title {
                display: block;
                color: var(--primary);
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
                margin-bottom: 10px;
            }
            .item-wrap {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                gap: 10px;
                margin-bottom: 10px;
                &:last-child {
                    margin-bottom: 0;
                }
                .item-title {
                    padding: 2px 10px;
                    border: 1px solid rgba(205, 205, 205, 1);
                    border-radius: 30px;
                    color: rgba(119, 119, 119, 1);
                    font-size: 12px;
                    line-height: 16px;
                    font-weight: 500;
                }
                .item-desc {
                    color: var(--text-color);
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: 300;
                }
            }
        }
    }
    .btn-holder {
        @media (min-width: 576px) {
            display: flex;
            gap: 21px;
        }
        .btn {
            width: 100%;
            &:first-child {
                @media (max-width: 575px) {
                    margin-bottom: 10px;
                }
            }
        }
    }
`;

const ItemSelection = styled.div`
    width: 100%;
    padding: 20px 15px;
    border: 1px solid rgba(205, 205, 205, 1);
    border-radius: 13px;
    margin-bottom: 15px;
    .head {
        display: flex;
        align-items: center;
        gap: 15px;
        cursor: pointer;
        @media (max-width: 575px) {
            flex-wrap: wrap;
        }
        .flex {
            display: flex;
            align-items: center;
            gap: 10px;
            .title {
                color: var(--text-color);
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
            }
            .status {
                padding: 5px 10px;
                border: 1px solid rgba(205, 205, 205, 1);
                border-radius: 30px;
                color: rgba(119, 119, 119, 1);
                font-size: 13px;
                line-height: 17px;
                font-weight: 400;
                &.required {
                    border: none;
                    color: rgba(224, 0, 0, 1);
                    background-color: rgba(224, 0, 0, 0.2);
                }
            }
        }
        .selected {
            color: var(--white);
            background-color: var(--primary);
            padding: 5px 10px;
            border-radius: 30px;
            font-size: 13px;
            line-height: 17px;
            font-weight: 400;
        }
    }
    .items {
        list-style: none;
        display: flex;
        gap: 15px;
        padding-top: 30px;
        @media (max-width: 767px) {
            flex-wrap: wrap;
        }
        li {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 16px;
            padding: 10px 20px;
            border: 1px solid rgba(236, 236, 236, 1);
            border-radius: 60px;
            &.active {
                background-color: rgba(245, 126, 42, 0.1);
                border: 1px solid rgba(245, 126, 42, 0.15);
            }
            .item-name {
                color: var(--text-color);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
            .input-field-wrap {
                margin-bottom: 0;
                label {
                    margin-bottom: 0;
                }
            }
        }
    }
`;

const SelectItems = ({formData, setFormData, setActiveTab}) => {
    const [form] = useForm();
    const [checkboxes, setCheckboxes] = useState({});
    const [itemUrl, setItemUrl] = useState(null);

    useEffect(() => {
        if (formData?.form1?.itemImg) {
            const objectUrl = URL.createObjectURL(formData.form1.itemImg);
            setItemUrl(objectUrl);

            return () => URL.revokeObjectURL(objectUrl);
        } else {
            setItemUrl(null);
        }
    }, [form, formData?.form1?.itemImg]);

    function handleSubmit(e) {
        setActiveTab(2);
    }
    return (
        <StyledSelectItems form={form} onSubmit={handleSubmit}>
            <div className="desc-wrap">
                <strong className="title">Select Items for Your Combo</strong>
                <span className="desc">Choose items from each category to create your perfect combo</span>
                <span className="items-selected">0 items selected</span>
            </div>
            {itemsData?.map((data, index) => (
                <ItemSelection key={index}>
                    <div className="head">
                        <div className="flex">
                            <RiArrowDownSLine size={26} color="var(--text-color)" />
                            <strong className="title">{data?.title}</strong>
                        </div>
                        <div className="flex" style={{flexGrow: "1"}}>
                            {data?.required && <span className="status required">Required</span>}
                            <span className="status">Select 1</span>
                        </div>
                        <span className="selected">0 Selected</span>
                    </div>
                    <ul className="items">
                        {data?.items?.map((data, index) => {
                            let item = data.replace(/\s/g, "");
                            return (
                                <li key={index} className={checkboxes[item] === true ? "active" : ""}>
                                    <Field
                                        label={<span className="item-name">{data}</span>}
                                        type="checkbox"
                                        name={item}
                                        value={checkboxes[item] === true}
                                        onChange={() =>
                                            setCheckboxes(prev => ({
                                                ...prev,
                                                [item]: !prev[item],
                                            }))
                                        }
                                    />
                                </li>
                            );
                        })}
                    </ul>
                </ItemSelection>
            ))}
            <div className="add-category-wrap">
                <strong className="title">Add More Categories</strong>
                <span className="desc">
                    Want to add more variety? You can include additional categories in your combo.
                </span>
                <ModalContainer
                    title="Add New Category"
                    width="983"
                    content={({onClose}) => <AddCategoryModal onClose={onClose} />}
                    btnComponent={({onClick}) => (
                        <span className="add-category" role="button" onClick={onClick}>
                            Add Category to Combo
                        </span>
                    )}
                />
            </div>
            <div className="selection-wrap">
                <img src={itemUrl ?? LunchImg} alt="img" className="img" />
                <div className="details">
                    <strong className="title">Current Selection</strong>
                    <div className="item-wrap">
                        <span className="item-title">Main Item</span>
                        <span className="item-desc">Zinger Burger</span>
                    </div>
                    <div className="item-wrap">
                        <span className="item-title">Side Item</span>
                        <span className="item-desc">Fries</span>
                    </div>
                </div>
            </div>
            <div className="btn-holder">
                <Button type="button" $gray className="btn" onClick={() => setActiveTab(0)}>
                    Previous
                </Button>
                <Button className="btn">Next</Button>
            </div>
        </StyledSelectItems>
    );
};

export default SelectItems;
